import UserSessionHistoryService from "../../services/UserSessionHistoryService/UserSessionHistoryService";

export interface MenuState {
    items: any[],
    selectedItem: any | null,
    selectedSubItem: any | null,
    toggle: boolean,
    showSubMenu: boolean,
    showUserMenu: boolean,
    fullScreen: boolean,
    showHelper: boolean,
    firstPendingEvaluation: boolean,
    prodQaDatabase: boolean,
    pinned: boolean,
    report: boolean,
    attendantAccess: any,
}

const initialState = {
    items: [],
    selectedItem: null,
    selectedSubItem: null,
    toggle: true,
    showSubMenu: false,
    showUserMenu: false,
    fullScreen: false,
    showHelper: false,
    firstPendingEvaluation: false,
    prodQaDatabase: false,
    pinned: false,
    report: false,
    attendantAccess: null,
}

type Action = { type: string, payload: any }

export const menuReducer = (state: MenuState = initialState, action: Action) => {
    const userSessionHistoryService = new UserSessionHistoryService({});

    const saveAccess = (data_: any) => {
        try {
            userSessionHistoryService.saveAccess(data_);
        }
        catch (error) {
            console.log(error);
            debugger
        }
    }

    switch (action.type) {
        case "MENU_UPDATE":
            return { ...state, items: action.payload };
        case "MENU_SELECTED_UPDATE":
            return { ...state, selectedItem: action.payload };
        // case "MENU_SUBSELECTED_UPDATE":
        //     action.payload && action.payload.id &&
        //         setSelectedPayLoad(action.payload.id)
        // return { ...state, selectedSubItem: action.payload };
        case "MENU_TOGGLE":
            return { ...state, toggle: action.payload };
        case "MENU_SUB_VISIBLE":
            return { ...state, showSubMenu: action.payload };
        case "MENU_USER_VISIBLE":
            return { ...state, showUserMenu: action.payload };
        case "MENU_FULLSCREEN":
            return { ...state, fullScreen: action.payload };
        case "MENU_HELPER_VISIBLE":
            return { ...state, showHelper: action.payload };
        case "MENU_FIRST_PENDING_EVALUATION":
            return { ...state, firstPendingEvaluation: action.payload };
        case "MENU_PROD_QA_DATABASE":
            return { ...state, prodQaDatabase: action.payload };
        case "MENU_PINNED":
            return { ...state, pinned: action.payload };
        case "MENU_REPORT":
            return { ...state, report: action.payload };
        case "MENU_ATTENDANT_ACCESS":
            saveAccess(action.payload);
            return { ...state, attendantAccess: action.payload };

        default:
            return state;
    }
}

// function setSelectedPayLoad(id: any) {
//     localStorage.setItem("HeyHo_LastMenuItem", id);
// }